import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import HomeContent from './home-content/home-content';
import { CookieBanner } from '../components/cookie-banner/cookie-banner';
import { NoAccountDialog } from '../components/dialog/no-account-dialog';
import { HelmetProvider } from 'react-helmet-async';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

export interface Parameters {
  hubName: string;
}

// keep it at the app entry level to avoid memory leaks.
// reference: https://github.com/staylor/react-helmet-async#usage
// reference: https://github.com/nfl/react-helmet#server-usage
const helmetContext = {};

export const Home: React.FC<RouteComponentProps> = () => {
  return (
    <HelmetProvider context={helmetContext}>
      <CookieBanner />
      <HomeContent />
      <Experiment name="DevHub_AuthN_AuthZ">
        <ExperimentControl>
          <></>
        </ExperimentControl>
        <ExperimentVariant bucket={1}>
          <NoAccountDialog />
        </ExperimentVariant>
      </Experiment>
    </HelmetProvider>
  );
};

Home.displayName = 'Home';

export default Home;
